import { useProcurifyIntl } from '@webapp/hooks'
import {
  type FinancialAccountTypeEnum,
  FinancialAccountTypes,
} from '@webapp/platform/banking/entities/enums/FinancialAccountTypeEnum'
import {
  type PaymentMethodCategoryType,
  PaymentMethodCategoryTypes,
} from '@webapp/platform/banking/entities/enums/PaymentMethodCategoryEnum'
import messages from '../messages'

export interface PaymentMethodCategoryOption {
  type: PaymentMethodCategoryType
  title: string
  description: string
  titleLabel?: string
}

export const useSelectPaymentMethodCategoryOptions = ({
  financialAccountType,
}: {
  financialAccountType: Nullable<FinancialAccountTypeEnum>
}) => {
  const intl = useProcurifyIntl()

  const isAirwallexUSD =
    financialAccountType === FinancialAccountTypes.AIRWALLEX_USD
  const isAirwallexCAD =
    financialAccountType === FinancialAccountTypes.AIRWALLEX_CAD

  const procurifyBillPaymentsLabel = intl.formatMessage(
    messages.procurifyBillPaymentsLabel
  )

  const paymentMethodCategoryOptions: PaymentMethodCategoryOption[] = []

  if (isAirwallexUSD) {
    paymentMethodCategoryOptions.push(
      {
        type: PaymentMethodCategoryTypes.US_DOMESTIC,
        title: intl.formatMessage(messages.usDomesticTitle),
        description: intl.formatMessage(messages.usDomesticDescription),
        titleLabel: procurifyBillPaymentsLabel,
      },
      {
        type: PaymentMethodCategoryTypes.INTERNATIONAL_US,
        title: intl.formatMessage(messages.internationalUsTitle),
        description: intl.formatMessage(messages.internationalUsDescription),
        titleLabel: procurifyBillPaymentsLabel,
      }
    )
  }

  if (isAirwallexCAD) {
    paymentMethodCategoryOptions.push({
      type: PaymentMethodCategoryTypes.CANADIAN_DOMESTIC,
      title: intl.formatMessage(messages.canadianDomesticTitle),
      description: intl.formatMessage(messages.canadianDomesticDescription),
      titleLabel: procurifyBillPaymentsLabel,
    })
  }

  paymentMethodCategoryOptions.push({
    type: PaymentMethodCategoryTypes.EXTERNAL,
    title: intl.formatMessage(messages.externalPaymentMethodTitle),
    description: intl.formatMessage(messages.externalPaymentMethodDescription),
  })

  return {
    paymentMethodCategoryOptions,
  }
}
